// ----------------------------------------------------------------------

const ROOTS = {
    AUTH: "/auth",
    DASHBOARD: "/dashboard",
    POST_JOB: "/post-job",
    INTERNAL_USER: "/internal-user",
}

// ----------------------------------------------------------------------

export const paths = {
    home: "/",
    faqs: "/faqs",
    /** Partner ATS entry: `/interview/:hash` (hash in path, not query). */
    atsPartnerInterview: (hash: string) => `/interview/${hash}`,
    minimalStore: "https://mui.com/store/items/minimal-dashboard/",
    // POST JOB
    postJob: {
        root: ROOTS.POST_JOB,
        jobDescription: `${ROOTS.POST_JOB}/job-description`,
        jobDetails: `${ROOTS.POST_JOB}/job-details`,
        interviewSetup: `${ROOTS.POST_JOB}/interview-setup`,
        reviewPublish: `${ROOTS.POST_JOB}/review-publish`,
    },
    // AUTH
    auth: {
        amplify: {
            signIn: `${ROOTS.AUTH}/amplify/sign-in`,
            verify: `${ROOTS.AUTH}/amplify/verify`,
            signUp: `${ROOTS.AUTH}/amplify/sign-up`,
            updatePassword: `${ROOTS.AUTH}/amplify/update-password`,
            resetPassword: `${ROOTS.AUTH}/amplify/reset-password`,
        },
        jwt: {
            signIn: `${ROOTS.AUTH}/jwt/sign-in`,
            signUp: `${ROOTS.AUTH}/jwt/sign-up`,
        },
        firebase: {
            signIn: `${ROOTS.AUTH}/firebase/sign-in`,
            verify: `${ROOTS.AUTH}/firebase/verify`,
            signUp: `${ROOTS.AUTH}/firebase/sign-up`,
            resetPassword: `${ROOTS.AUTH}/firebase/reset-password`,
        },
        auth0: {
            signIn: `${ROOTS.AUTH}/auth0/sign-in`,
        },
        supabase: {
            signIn: `${ROOTS.AUTH}/supabase/sign-in`,
            verify: `${ROOTS.AUTH}/supabase/verify`,
            signUp: `${ROOTS.AUTH}/supabase/sign-up`,
            updatePassword: `${ROOTS.AUTH}/supabase/update-password`,
            resetPassword: `${ROOTS.AUTH}/supabase/reset-password`,
        },
    },
    // DASHBOARD
    dashboard: {
        root: ROOTS.DASHBOARD,
        onboarding: `${ROOTS.DASHBOARD}/onboarding`,
        interviews: `${ROOTS.DASHBOARD}/interviews`,
        selections: `${ROOTS.DASHBOARD}/selections`,
        clients: `${ROOTS.DASHBOARD}/clients`,
        bulkUpload: `${ROOTS.DASHBOARD}/bulk-upload`,
        userManagement: `${ROOTS.DASHBOARD}/user-management`,
        interviewForm: `${ROOTS.DASHBOARD}/interviews/interview-form`,
        leadForm: `${ROOTS.DASHBOARD}/lead-form`,
        clientForm: `${ROOTS.DASHBOARD}/clients/client-form`,
        selectionForm: `${ROOTS.DASHBOARD}/selections/selection-form`,
        mandateForm: `${ROOTS.DASHBOARD}/mandates/mandate-form`,
        three: `${ROOTS.DASHBOARD}/three`,
        publicApplyWeb: `${ROOTS.DASHBOARD}/jobDetails/:id`,
        publicApplyPhone: `${ROOTS.DASHBOARD}/jobDetailsV2/:id`,
        publicApplyReschedule: `${ROOTS.DASHBOARD}/reschedule/:rescheduleHash`,
        jobOverview: `${ROOTS.DASHBOARD}/jobOverview/:id`,
        jobWithId: `${ROOTS.DASHBOARD}/job/`,
        group: {
            root: `${ROOTS.DASHBOARD}/group`,
            five: `${ROOTS.DASHBOARD}/group/five`,
            six: `${ROOTS.DASHBOARD}/group/six`,
        },
        client: {
            root: `${ROOTS.DASHBOARD}/client-details/:id`,
            details: (id: string) => `${ROOTS.DASHBOARD}/client-details/${id}`,
        },
        interview: {
            details: (id: string) => `${ROOTS.DASHBOARD}/interview-details/${id}`,
        },
        lead: {
            details: (id: string) => `${ROOTS.DASHBOARD}/lead-details/${id}`,
        },
        mandate: {
            root: `${ROOTS.DASHBOARD}/job-details/:id`,
            details: (id: string) => `${ROOTS.DASHBOARD}/job-details/${id}`,
        },
        selection: {
            root: `${ROOTS.DASHBOARD}/selection-details/:id`,
            details: (id: string) => `${ROOTS.DASHBOARD}/selection-details/${id}`,
        },
        credits: {
            root: `${ROOTS.DASHBOARD}/credits`,
        },
        questionBank: `${ROOTS.DASHBOARD}/question-bank`,
    },
    internalUser: {
        root: `${ROOTS.INTERNAL_USER}`,
        workspaces: `${ROOTS.INTERNAL_USER}/workspaces`,
        credits: `${ROOTS.INTERNAL_USER}/credits`,
        jobsAndLeads: `${ROOTS.INTERNAL_USER}/jobs-and-leads`,
        jobLeadsDetail: (jobId: string) => `${ROOTS.INTERNAL_USER}/jobs-and-leads/${jobId}`,
        generateOtp: `${ROOTS.INTERNAL_USER}/generate-otp`,
        teamAssignments: `${ROOTS.INTERNAL_USER}/team-assignments`,
        prompts: `${ROOTS.INTERNAL_USER}/prompts`,
    },
}
